import { JSONSchema6 } from "json-schema";

const getChargeSchema: JSONSchema6 = {
    title: "Get Charge",
    description: "Get Charge details such as charge amount and authorization state. Use this operation to determine if authorization or capture was successful.",
    properties: {
        "pathParam": {
            title: "chargeId",
            type: "string",
        }
    },
    required: ["pathParam"]
}

export default getChargeSchema